import React, { useEffect, useState } from "react";
import PurchaseCreatePage from "../../../../../entities/DashboardPage/AccountingModule/Purchase/PurchaseCreate";
import AuthService from "../../../../../api/AuthService";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../../context/AlertContext";
import { useNavigate } from "react-router-dom";

const PurchaseCreate = () => {
  const [itemList, setItemList] = useState();
  const [supplierList, setSupplierList] = useState();
  const [loading, setLoading] = useState();
  const [data, setData] = useState()
  const navigate = useNavigate();
  const { showAlert } = useAlert();

  useEffect(() => {
    getItem();
    getSupplierList();
    getAllBanks();
  }, []);

  const handleAddPurchase = async (payload) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true)
    try {
      const result = await AuthService.createPurchaseOrder(payload);
      if (result?.success === true) {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
        navigate("/dashboard/purchaseOrder");
        getSupplierList();
      } else {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false)
      LoaderHelper.loaderStatus(false);
    }
  };
  const getSupplierList = async (text, sort, page) => {
    setLoading(true);
    try {
      const result = await AuthService.getSupplier(text, sort, page);
      if (result?.success) {
        setSupplierList(result?.data?.suppliers);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const getItem = async (text) => {
    setLoading(true);

    try {
      const result = await AuthService.getItemsList(text);
      if (result?.success) {
        setItemList(result?.data?.items);
        setLoading(false);
      } else {

        setLoading(false);
      }
    } catch (error) {

      setLoading(false);
    }
  };

  const getAllBanks = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAllBanks();
      if (result?.success) {
        setData(result?.data?.bankAccounts);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getsupplierPurchase = async (supplierName) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getSuppliersPurchase(supplierName);
      if (result?.success) {
        const data = result?.data
        navigate("/dashboard/supplierDetails", {
          state: {
            supplierList,
            purchaseList: data,
          },
        })
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  return (
    <PurchaseCreatePage data={data} itemList={itemList} handleAdd={handleAddPurchase} loading={loading} handleItemList={getItem} supplierList={supplierList} handleSupplierList={getSupplierList} />
  )

}

export default PurchaseCreate;
